/**
 * API Gateway
 * API Gateway Единая точка входа для android, ios и web.  Модели ответов сервиса соответствуют спецификации, кроме случаев, когда возможны технические ответы (например, от ratelimiter или qrator). 
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/* tslint:disable:no-unused-variable member-ordering */

import { Inject, Injectable, Optional }                      from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams,
         HttpResponse, HttpEvent, HttpParameterCodec, HttpContext 
        }       from '@angular/common/http';
import { CustomHttpParameterCodec }                          from '../encoder';
import { Observable }                                        from 'rxjs';
import { API_OPTIONS_CONTEXT, ApiOptions }                   from '../api/api'

// @ts-ignore
import { BadRequestResponse } from '../model/badRequestResponse';
// @ts-ignore
import { BaseResponse } from '../model/baseResponse';
// @ts-ignore
import { LentaSiteJRPCError } from '../model/lentaSiteJRPCError';
// @ts-ignore
import { RegionListResponse } from '../model/regionListResponse';
// @ts-ignore
import { RegionUserResponse } from '../model/regionUserResponse';

// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS }                     from '../variables';
import { Configuration }                                     from '../configuration';


export interface RegionListRequestParams {
    /** Сессионный токен */
    sessionToken: string;
    /** Уникальный идентификатор устройства */
    deviceID: string;
    /** Канал продаж (Retail brand) */
    xRetailBrand: 'lo' | 'utk' | 'smy' | 'mntk' | 'obi' | 'antares' | 'remi' | 'ulybka_radugi' | 'superjam';
    /** Источник (платформа) запроса */
    xPlatform: 'loapp' | 'omniapp' | 'loweb' | 'omniweb' | 'tgbot01' | 'mntkapp' | 'tablet' | 'kiosk' | 'callcenter' | 'tsipk';
    /** Бренд устройства */
    xDeviceBrand?: string;
    /** Название устройства */
    xDeviceName?: string;
    /** Версия ОС устройства */
    xDeviceOSVersion?: string;
    /** Идентификатор B2B организации */
    xOrganizationID?: string;
    /** ОС устройства */
    xDeviceOS?: string;
    /** Доставка / Самовывоз */
    xDeliveryMode?: 'delivery' | 'pickup' | 'shop';
    /** Метки витрины (storefront labels) для проброса в нижележащие сервисы. Более масштабируемая замена заголовков X-Real-Retail-Brand, X-Device-OS и т.п. Только ASCII-символы, максимальная длина 4096.  */
    xStorefrontLabels?: string;
}

export interface RegionUserRequestParams {
    /** Сессионный токен */
    sessionToken: string;
    /** Уникальный идентификатор устройства */
    deviceID: string;
    /** Канал продаж (Retail brand) */
    xRetailBrand: 'lo' | 'utk' | 'smy' | 'mntk' | 'obi' | 'antares' | 'remi' | 'ulybka_radugi' | 'superjam';
    /** Источник (платформа) запроса */
    xPlatform: 'loapp' | 'omniapp' | 'loweb' | 'omniweb' | 'tgbot01' | 'mntkapp' | 'tablet' | 'kiosk' | 'callcenter' | 'tsipk';
    /** Бренд устройства */
    xDeviceBrand?: string;
    /** Название устройства */
    xDeviceName?: string;
    /** Версия ОС устройства */
    xDeviceOSVersion?: string;
    /** Идентификатор B2B организации */
    xOrganizationID?: string;
    /** ОС устройства */
    xDeviceOS?: string;
    /** Доставка / Самовывоз */
    xDeliveryMode?: 'delivery' | 'pickup' | 'shop';
    /** По данному заголовку определяются ТК для гостевой сессии */
    xDomain?: string;
    /** Клиент и версия приложения */
    client?: string;
    /** Метки витрины (storefront labels) для проброса в нижележащие сервисы. Более масштабируемая замена заголовков X-Real-Retail-Brand, X-Device-OS и т.п. Только ASCII-символы, максимальная длина 4096.  */
    xStorefrontLabels?: string;
}


@Injectable({
  providedIn: 'root'
})
export class RegionService {

    protected basePath = 'https://api.lenta.com/v1';
    public defaultHeaders = new HttpHeaders();
    public configuration = new Configuration();
    public encoder: HttpParameterCodec;

    constructor(protected httpClient: HttpClient, @Optional()@Inject(BASE_PATH) basePath: string|string[], @Optional() configuration: Configuration) {
        if (configuration) {
            this.configuration = configuration;
        }
        if (typeof this.configuration.basePath !== 'string') {
            if (Array.isArray(basePath) && basePath.length > 0) {
                basePath = basePath[0];
            }

            if (typeof basePath !== 'string') {
                basePath = this.basePath;
            }
            this.configuration.basePath = basePath;
        }
        this.encoder = this.configuration.encoder || new CustomHttpParameterCodec();
    }


    // @ts-ignore
    private addToHttpParams(httpParams: HttpParams, value: any, key?: string): HttpParams {
        if (typeof value === "object" && value instanceof Date === false) {
            httpParams = this.addToHttpParamsRecursive(httpParams, value);
        } else {
            httpParams = this.addToHttpParamsRecursive(httpParams, value, key);
        }
        return httpParams;
    }

    private addToHttpParamsRecursive(httpParams: HttpParams, value?: any, key?: string): HttpParams {
        if (value == null) {
            return httpParams;
        }

        if (typeof value === "object") {
            if (Array.isArray(value)) {
                (value as any[]).forEach( elem => httpParams = this.addToHttpParamsRecursive(httpParams, elem, key));
            } else if (value instanceof Date) {
                if (key != null) {
                    httpParams = httpParams.append(key, (value as Date).toISOString().substring(0, 10));
                } else {
                   throw Error("key may not be null if value is Date");
                }
            } else {
                Object.keys(value).forEach( k => httpParams = this.addToHttpParamsRecursive(
                    httpParams, value[k], key != null ? `${key}.${k}` : k));
            }
        } else if (key != null) {
            httpParams = httpParams.append(key, value);
        } else {
            throw Error("key may not be null if value is not object or array");
        }
        return httpParams;
    }

    /**
     * Список регионов
     * Список регионов
     * @param requestParameters
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public regionList(requestParameters: RegionListRequestParams, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext}): Observable<RegionListResponse>;
    public regionList(requestParameters: RegionListRequestParams, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext}): Observable<HttpResponse<RegionListResponse>>;
    public regionList(requestParameters: RegionListRequestParams, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext}): Observable<HttpEvent<RegionListResponse>>;
    public regionList(requestParameters: RegionListRequestParams, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext}): Observable<any> {
        const sessionToken = requestParameters.sessionToken;
        if (sessionToken === null || sessionToken === undefined) {
            throw new Error('Required parameter sessionToken was null or undefined when calling regionList.');
        }
        const deviceID = requestParameters.deviceID;
        if (deviceID === null || deviceID === undefined) {
            throw new Error('Required parameter deviceID was null or undefined when calling regionList.');
        }
        const xRetailBrand = requestParameters.xRetailBrand;
        if (xRetailBrand === null || xRetailBrand === undefined) {
            throw new Error('Required parameter xRetailBrand was null or undefined when calling regionList.');
        }
        const xPlatform = requestParameters.xPlatform;
        if (xPlatform === null || xPlatform === undefined) {
            throw new Error('Required parameter xPlatform was null or undefined when calling regionList.');
        }
        const xDeviceBrand = requestParameters.xDeviceBrand;
        const xDeviceName = requestParameters.xDeviceName;
        const xDeviceOSVersion = requestParameters.xDeviceOSVersion;
        const xOrganizationID = requestParameters.xOrganizationID;
        const xDeviceOS = requestParameters.xDeviceOS;
        const xDeliveryMode = requestParameters.xDeliveryMode;
        const xStorefrontLabels = requestParameters.xStorefrontLabels;

        let localVarHeaders = this.defaultHeaders;
        if (sessionToken !== undefined && sessionToken !== null) {
            localVarHeaders = localVarHeaders.set('SessionToken', String(sessionToken));
        }
        if (deviceID !== undefined && deviceID !== null) {
            localVarHeaders = localVarHeaders.set('DeviceID', String(deviceID));
        }
        if (xRetailBrand !== undefined && xRetailBrand !== null) {
            localVarHeaders = localVarHeaders.set('X-Retail-Brand', String(xRetailBrand));
        }
        if (xPlatform !== undefined && xPlatform !== null) {
            localVarHeaders = localVarHeaders.set('X-Platform', String(xPlatform));
        }
        if (xDeviceBrand !== undefined && xDeviceBrand !== null) {
            localVarHeaders = localVarHeaders.set('X-Device-Brand', String(xDeviceBrand));
        }
        if (xDeviceName !== undefined && xDeviceName !== null) {
            localVarHeaders = localVarHeaders.set('X-Device-Name', String(xDeviceName));
        }
        if (xDeviceOSVersion !== undefined && xDeviceOSVersion !== null) {
            localVarHeaders = localVarHeaders.set('X-Device-OS-Version', String(xDeviceOSVersion));
        }
        if (xOrganizationID !== undefined && xOrganizationID !== null) {
            localVarHeaders = localVarHeaders.set('X-Organization-ID', String(xOrganizationID));
        }
        if (xDeviceOS !== undefined && xDeviceOS !== null) {
            localVarHeaders = localVarHeaders.set('X-Device-OS', String(xDeviceOS));
        }
        if (xDeliveryMode !== undefined && xDeliveryMode !== null) {
            localVarHeaders = localVarHeaders.set('X-Delivery-Mode', String(xDeliveryMode));
        }
        if (xStorefrontLabels !== undefined && xStorefrontLabels !== null) {
            localVarHeaders = localVarHeaders.set('X-Storefront-Labels', String(xStorefrontLabels));
        }

        let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
        if (localVarHttpHeaderAcceptSelected === undefined) {
            // to determine the Accept header
            const httpHeaderAccepts: string[] = [
                'application/json'
            ];
            localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        }
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        const apiOptions: ApiOptions = {
          team: 'GR',
        };

        let localVarHttpContext: HttpContext | undefined = options && options.context;
        if (localVarHttpContext === undefined) {
            localVarHttpContext = new HttpContext();
        }
        localVarHttpContext.set(API_OPTIONS_CONTEXT, apiOptions)


        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/region/list`;
        return this.httpClient.request<RegionListResponse>('get', `${this.configuration.basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                responseType: <any>responseType_,
                withCredentials: this.configuration.withCredentials,
                headers: localVarHeaders,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Данные о регионе пользователя
     * Данные о регионе пользователя
     * @param requestParameters
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public regionUser(requestParameters: RegionUserRequestParams, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext}): Observable<RegionUserResponse>;
    public regionUser(requestParameters: RegionUserRequestParams, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext}): Observable<HttpResponse<RegionUserResponse>>;
    public regionUser(requestParameters: RegionUserRequestParams, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext}): Observable<HttpEvent<RegionUserResponse>>;
    public regionUser(requestParameters: RegionUserRequestParams, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext}): Observable<any> {
        const sessionToken = requestParameters.sessionToken;
        if (sessionToken === null || sessionToken === undefined) {
            throw new Error('Required parameter sessionToken was null or undefined when calling regionUser.');
        }
        const deviceID = requestParameters.deviceID;
        if (deviceID === null || deviceID === undefined) {
            throw new Error('Required parameter deviceID was null or undefined when calling regionUser.');
        }
        const xRetailBrand = requestParameters.xRetailBrand;
        if (xRetailBrand === null || xRetailBrand === undefined) {
            throw new Error('Required parameter xRetailBrand was null or undefined when calling regionUser.');
        }
        const xPlatform = requestParameters.xPlatform;
        if (xPlatform === null || xPlatform === undefined) {
            throw new Error('Required parameter xPlatform was null or undefined when calling regionUser.');
        }
        const xDeviceBrand = requestParameters.xDeviceBrand;
        const xDeviceName = requestParameters.xDeviceName;
        const xDeviceOSVersion = requestParameters.xDeviceOSVersion;
        const xOrganizationID = requestParameters.xOrganizationID;
        const xDeviceOS = requestParameters.xDeviceOS;
        const xDeliveryMode = requestParameters.xDeliveryMode;
        const xDomain = requestParameters.xDomain;
        const client = requestParameters.client;
        const xStorefrontLabels = requestParameters.xStorefrontLabels;

        let localVarHeaders = this.defaultHeaders;
        if (sessionToken !== undefined && sessionToken !== null) {
            localVarHeaders = localVarHeaders.set('SessionToken', String(sessionToken));
        }
        if (deviceID !== undefined && deviceID !== null) {
            localVarHeaders = localVarHeaders.set('DeviceID', String(deviceID));
        }
        if (xRetailBrand !== undefined && xRetailBrand !== null) {
            localVarHeaders = localVarHeaders.set('X-Retail-Brand', String(xRetailBrand));
        }
        if (xPlatform !== undefined && xPlatform !== null) {
            localVarHeaders = localVarHeaders.set('X-Platform', String(xPlatform));
        }
        if (xDeviceBrand !== undefined && xDeviceBrand !== null) {
            localVarHeaders = localVarHeaders.set('X-Device-Brand', String(xDeviceBrand));
        }
        if (xDeviceName !== undefined && xDeviceName !== null) {
            localVarHeaders = localVarHeaders.set('X-Device-Name', String(xDeviceName));
        }
        if (xDeviceOSVersion !== undefined && xDeviceOSVersion !== null) {
            localVarHeaders = localVarHeaders.set('X-Device-OS-Version', String(xDeviceOSVersion));
        }
        if (xOrganizationID !== undefined && xOrganizationID !== null) {
            localVarHeaders = localVarHeaders.set('X-Organization-ID', String(xOrganizationID));
        }
        if (xDeviceOS !== undefined && xDeviceOS !== null) {
            localVarHeaders = localVarHeaders.set('X-Device-OS', String(xDeviceOS));
        }
        if (xDeliveryMode !== undefined && xDeliveryMode !== null) {
            localVarHeaders = localVarHeaders.set('X-Delivery-Mode', String(xDeliveryMode));
        }
        if (xDomain !== undefined && xDomain !== null) {
            localVarHeaders = localVarHeaders.set('X-Domain', String(xDomain));
        }
        if (client !== undefined && client !== null) {
            localVarHeaders = localVarHeaders.set('Client', String(client));
        }
        if (xStorefrontLabels !== undefined && xStorefrontLabels !== null) {
            localVarHeaders = localVarHeaders.set('X-Storefront-Labels', String(xStorefrontLabels));
        }

        let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
        if (localVarHttpHeaderAcceptSelected === undefined) {
            // to determine the Accept header
            const httpHeaderAccepts: string[] = [
                'application/json'
            ];
            localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        }
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        const apiOptions: ApiOptions = {
          team: 'GR',
        };

        let localVarHttpContext: HttpContext | undefined = options && options.context;
        if (localVarHttpContext === undefined) {
            localVarHttpContext = new HttpContext();
        }
        localVarHttpContext.set(API_OPTIONS_CONTEXT, apiOptions)


        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/region/user`;
        return this.httpClient.request<RegionUserResponse>('get', `${this.configuration.basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                responseType: <any>responseType_,
                withCredentials: this.configuration.withCredentials,
                headers: localVarHeaders,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

}
